// flow weak

import React, {
    PureComponent,
     useState, useEffect 
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import Dialog from 'material-ui/Dialog';
  import FlatButton from 'material-ui/FlatButton';
  import RaisedButton from 'material-ui/RaisedButton';
  import ReactTable from "react-table"; 
  import { Link }         from 'react-router-dom';

  
  
  class CallStatus extends PureComponent {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = {
        venue: props.props.statsTable.revenue_per_month.requested_venue_id,
        missed_calls : [],
        completed_calls : [],
        outgoing_calls:[],
        selected_values: [],
        is_missed_call_checked : true,
        is_incoming_call_checked : true,
        open_audio : false,
        recording : ''
        
      };
      this.handleChange = this.handleChange.bind(this);
      // this.playAudio = this.playAudio.bind(this);
      this.handleAudioClose = this.handleAudioClose.bind(this);
      this.showMissedCalls = this.showMissedCalls.bind(this);
    }
  
    componentDidMount() {
        this.getCalls();
    }

    locationChanged() {
    this.setState({venue:this.props.props.statsTable.revenue_per_month.requested_venue_id}, () => {
      this.getCalls()  
    })
    }


    getCalls(){
     const url = `${getLocationOrigin()}/calls/partner_fetch_calls/?venue=${this.state.venue}`;
     const options = {...defaultOptions};
     console.log('get calls')

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
           this.setState({missed_calls:data.result.incoming_calls.missed_calls,completed_calls:data.result.incoming_calls.completed_calls, selected_values: data.result.incoming_calls.missed_calls,outgoing_calls:data.result.outgoing_calls});
           // alert("fix");
       }).catch(error => error);
    }

    handleChange(event) {
        var value = event.target.value
        console.log('comment')
        console.log(value)
        value = value.trim()
        this.setState({comment: value});
        // this.getAmount(this.state.equipment_details)
    }

    connectCall(call) {
      console.log('call')
      console.log(call)
      const url = `${getLocationOrigin()}/calls/connect_customer/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                                          'customer_no': call.call_from,
                                          'source':'CM'
                                            });
      console.log('Going to fetch');
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(function(response){                     
            alert(response.message);
            // props.history.goBack();
        })
        .catch(error => {
          console.log(error);
          alert(error.message);
        });
    }

    showMissedCalls(event) {
      var name = event.target.name;
      if(name === "missed"){
        this.setState({selected_values:this.state.missed_calls, is_missed_call_checked: true})
      }
      else if(name === 'completed'){
        this.setState({selected_values: this.state.completed_calls, is_missed_call_checked: false})
      }
      else{
        this.setState({selected_values: this.state.outgoing_calls, is_incoming_call_checked: true})
      }
    }

    getTrProps = (state, rowInfo, instance) => {
      return {
        style: {
          background:'white',
          color:'black'
        }
      };
    };

    playAudio(url) {
      const audio = url;
      this.setState({open_audio:true,recording:audio});
    };

    callBack(id) {
      var call = this.state.selected_values.find(temp => temp.id == id)
      this.connectCall(call)
    }

    handleAudioClose=()=>{
      this.setState({open_audio:false})
    } 

  
    render() {
      console.log('amount')
      console.log(this.state.selected_values) 
      const data = this.state.selected_values;

      if(this.state.venue != this.props.props.statsTable.revenue_per_month.requested_venue_id){
        this.locationChanged()
      }

      const dialog_ok = [
        <FlatButton
          label="OK"
          primary={true}
          onClick={this.handleAudioClose}
        />
      ];
      

      const columns = [{  
       Header: 'Customer',  
       accessor: 'customer'  
       },{  
       Header: 'Mobile Number',  
       accessor: 'call_from',
       Cell: ({row}) => (<span>{row.call_from ? row.call_from.slice(0,3)+'***'+row.call_from.slice(6,10):row.call_from}</span>),
       minWidth: 100
       },{  
       Header: 'Venue',  
       accessor: 'venue'  
       },{  
       Header: 'Date',  
       accessor: 'date_created'
       },{  
       Header: 'Start Time',  
       accessor: 'start_time'
       },
       {  
       Header: 'End Time',  
       accessor: 'end_time'
       },
       {
       Header: 'Buddy',
       accessor: 'buddy'
       },
       {
       Header: 'Status',
       accessor: 'call_status',
       Cell: cellInfo => (<span className={cellInfo.original.call_status == 'no-answer' ?'badge badge-danger' : (cellInfo.original.call_status == 'busy' ? 'badge badge-warning': (cellInfo.original.call_status == 'completed' ? 'badge badge-success' : 'badge badge-default'))} style={{color:'white'}}>{cellInfo.original.call_status}</span>)
       },
       {
       Header: 'Duration',
       accessor: 'duration',
       Cell: ({row}) =>(<span> {row.duration ? row.duration +' seconds' : ''}</span>)
       },
       {
       Header: 'Call Type',
       accessor: 'call_type_display',
       },
       {  
       Header: 'Actions',  
       accessor: 'id',
       maxWidth: 70,
       Cell: ({row}) => (<span onClick={()=>this.callBack(row.id)} className='badge badge-default' style={{cursor:'pointer',backgroundColor:'#32CD32',color:'white'}}><i className='fa fa-phone fa-2x'></i></span>)
       },
       {  
       Header: 'Recording',  
       accessor: 'recording_url',
       maxWidth: 70,
       Cell: ({row}) => (<i onClick={()=>this.playAudio(row.recording_url)} className='fa fa-volume-up fa-2x' style={{cursor:'pointer',display:'block',margin:'auto'}} />)
       }
       ];

       
      return(
        <div className="col-md-12 row">

          <div className="col-md-12 table-bordered" style={{marginTop:'10px',marginLeft:'15px'}}>
            <div style={{float:'right',margin:'10px',display:'flex'}}>
              <button className='btn btn-warning active col-md-4' name='missed' aria-pressed="true" style={{color:'black'}} onClick={this.showMissedCalls}>Missed Calls </button>
              <button type='button' aria-pressed="true" className='btn btn-primary active col-md-4' name='completed' onClick={this.showMissedCalls}>Completed Calls </button>
              <button className='btn active col-md-4' style={{backgroundColor:'#e3b271'}} aria-pressed="true" name='outgoing' onClick={this.showMissedCalls}>Outgoing Calls </button>
            </div>
          
            <ReactTable  
                    data={data}  
                    className="-striped -highlight"
                    columns={columns}  
                    defaultPageSize = {100}  
                    pageSizeOptions = {[100,200,500]} 
                    filterable={true}
                    showPagination={data.length > 100}
                    showPaginationTop = {data.length > 100}
                    style = {{background:'#9370DB'}}
                    getTrProps = {this.getTrProps}
                    defaultFilterMethod = {(filter, row, column) => {
                      const id = filter.pivotId || filter.id
                      return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true
                    }}
                   
            >

              {
                //To show the record count on top  
                (state, makeTable, instance) => {

                  let recordsInfoText = "";

                  const { filtered, pageRows, pageSize, sortedData, page } = state;

                  if (sortedData && sortedData.length > 0) {
                    let isFiltered = filtered.length > 0;

                    let totalRecords = sortedData.length;

                    let recordsCountFrom = page * pageSize + 1;

                    let recordsCountTo = recordsCountFrom + pageRows.length - 1;

                    if (isFiltered){
                      recordsInfoText = `${totalRecords} filtered records`;
                    }
                    else {
                      recordsInfoText = `${totalRecords} records`;
                    }
                  } else {
                      recordsInfoText = "No records";
                    }
                  return (
                    <div className="main-grid">
                      <div className="above-table text-right">
                        <div className="col-sm-12 records-info">
                          <span className="">{recordsInfoText}</span>
                        </div>
                      </div>
                      {makeTable()}
                      
                    </div>

                  );
                }
              }

            </ReactTable>

          </div>

          {
            this.state.open_close_dialog ?

            <Dialog
                    actions={dialog_actions}
                    modal={false}
                    open={this.state.open_close_dialog}
                    onRequestClose={this.handleClose}
                    autoDetectWindowHeight={true}
                    autoScrollBodyContent={true}
                    // scroll={scroll}
                    // dividers={scroll === 'paper'}
                  >

              <div style={{display:'flex',flexDirection:'column'}}>
                <div style={styles.main_header} className="col-md-12">
                  <h4 style={{textAlign:'center'}}> Close Ticket </h4>
                </div>
                <span style={{marginBottom:'10px'}}> Content of ticket </span>
                <pre> {this.state.selected_ticket.content} </pre>
                <span style={{marginBottom:'10px'}}> Please explain briefly about the solution provided </span>
                <textarea rows="5" onChange={this.handleChange}/>
              </div>
            </Dialog>
            :
            ""
          }

          {
            this.state.open_edit_dialog ?

            <Dialog
                    actions={dialog_edit}
                    modal={false}
                    open={this.state.open_edit_dialog}
                    onRequestClose={this.handleEditClose}
                    autoDetectWindowHeight={true}
                    autoScrollBodyContent={true}
                    // scroll={scroll}
                    // dividers={scroll === 'paper'}
                  >
              <div style={{display:'flex',flexDirection:'column'}}>

                <div style={styles.main_header} className="col-md-12">
                  <h4 style={{textAlign:'center'}}> Edit Ticket </h4>
                </div>

                <div style={{display:'flex',flexDirection:'row',margin:'20px'}}>
                  <span style={{marginBottom:'10px'}}> Reassign ticket - </span>
                  <select name="assigned_to" className="col-md-6" style={{marginLeft:'15px'}}
                  onChange={this.handleEditChange} value={this.state.edit_details.assigned_to}>
                  <option key={0} value={null}></option>
                  {
                    this.state.buddies_arr.map((buddy, index) => (
                      <option key={buddy.id} value={buddy.id}>{buddy.name}</option>
                    ))
                  }
                </select>
                </div>

                <div style={{display:'flex',flexDirection:'row',margin:'20px'}}>
                  <span style={{marginBottom:'10px'}}> Change Priority - </span>
                  <select name="priority" className="col-md-6" value={this.state.edit_details.priority} style={{marginLeft:'15px'}}
                  onChange={this.handleEditChange}>
                  {
                    Object.keys(this.state.priority_arr).map((key, index) => (
                      <option key={index} value={key}>{this.state.priority_arr[key]}</option>
                    ))
                  }
                  </select>
                </div>

                <div style={{display:'flex',flexDirection:'column'}}>
                  <span style={{marginBottom:'10px'}}> Please state the reason for change </span>
                  <textarea rows="5" onChange={this.handleChange}/>
                </div>
              </div>
            </Dialog>
            :
            ""
          }

          {
            this.state.open_audio ?
              <Dialog
                    actions={dialog_ok}
                    modal={false}
                    open={this.state.open_audio}
                    onRequestClose={this.handleAudioClose}
                    autoDetectWindowHeight={true}
                    autoScrollBodyContent={true}>

                <div style={{display:'flex',flexDirection:'column'}}>
                    <div style={styles.main_header} className="col-md-12">
                      <h4 style={{textAlign:'center'}}> Listen Audio </h4>
                    </div>
                    <div>
                      <audio ref="audio_tag" src={this.state.recording} controls/>
                    </div>
                </div>
              </Dialog>
            :
            ""

          }
        </div>

          
        
      );
    }
  }
  
  export default CallStatus;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/callStatus/index.js